import template from './calendarWrapper.html';
import controller from './calendarWrapper.controller';

let component = {
  restrict: 'E',
  template,
  controller,
  controllerAs: 'vm',
  bindings: {
    isOnline: '<',
    staffUser: '<'
  }
};

export default component;
